module.exports = __webpack_public_path__ + "img/2.545a39b1.png";